module.exports = __webpack_public_path__ + "img/usdc.7dfa6cbc.png";